




























import { Component, Vue } from 'vue-property-decorator';
import { getLocations } from '@/api/location';

interface ILocation {
  id: string;
  location_code: string;
  name: string;
  status: number;
  warehouse_code: string;
}

@Component({
  name: 'LocationSetting',
})
export default class extends Vue {
  private locations: ILocation[] = [];

  created() {
    this.getLocations();
  }

  private async getLocations() {
    this.$overlay(true);
    const { data } = await getLocations();
    this.$overlay(false);
    this.locations = data;
  }

  private setLocation(locationCode: string, locationName: string) {
    this.$store.dispatch('user/setLocation', { locationCode, locationName });
    this.$toast('Successful setup', { color: 'success', icon: 'fas fa-info-circle' });
    this.$router.push({ name: 'Home' });
  }

  get locationsSort() {
    return this.locations.sort((n1, n2) => Number(n1.location_code) - Number(n2.location_code));
  }
}
